import { MODALS_ENUM } from "@constants/Modals";
import styles from "./EditNotificationGroup.module.scss";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import trash from "@assets/redesign/icons/trash.svg";
import { Button, Checkbox, Divider, Radio, Switch, TimePicker } from "antd";
import { Input } from "@components/global/new/Input/Input";
import apple from "@assets/redesign/icons/apple.svg";
import mail from "@assets/redesign/icons/mail.svg";
import telegram from "@assets/redesign/icons/telegram.svg";

type EditNotificationGroupProps = CommonModalPropsI & {
  name?: string;
};

function EditNotificationGroup(props: EditNotificationGroupProps) {
  return <div className={styles.wrapper}>
    <div className={styles.titleWrapper}>
      <h4 className={styles.title}>
        {props.name ? `${props.formatMessage({
          id: "modal.editNotificationGroup.title.edit"
        })}: ${props.name}` : props.formatMessage({
          id: "modal.editNotificationGroup.title.create"
        })}
      </h4>
      {props.name && <div className={styles.delete}>
        <img src={trash} alt="" />
        <span>{props.formatMessage({ id: "modal.editNotificationGroup.buttons.deleteGroup" })}</span>
      </div>}
    </div>
    <Divider className={styles.headDivider} />
    <div className={styles.content}>
      <div>
        <Input
          outlined
          label={<span className={styles.label}>
            {props.formatMessage({ id: "modal.editNotificationGroup.title.name" })}
          </span>}
          defaultValue={props.name}
        />
        <div className={styles.status}>
          <span>
            {props.formatMessage({ id: "modal.editNotificationGroup.title.status" })}
          </span>
          <Switch checked />
          <span>
            {props.formatMessage({ id: "modal.editNotificationGroup.title.status.active" })}
          </span>
        </div>
      </div>
      <Divider className={styles.divider} />
      <div>
        <Input
          outlined
          label={<span className={styles.label}>
            {props.formatMessage({ id: "modal.editNotificationGroup.title.hashrateBelow" })}
          </span>}
          addonAfter="%"
        />
        <Input
          outlined
          label={<span className={styles.label}>
            {props.formatMessage({ id: "modal.editNotificationGroup.title.from" })}
          </span>}
          addonAfter="TH/s"
        />
        <Input
          outlined
          label={<span className={styles.label}>
            {props.formatMessage({ id: "modal.editNotificationGroup.title.rejects" })}
          </span>}
          addonAfter="%"
        />
      </div>
      <Divider className={styles.divider} />
      <div>
        <div className={styles.reportMode}>
          <div className={styles.reportModeTitle}>{props.formatMessage({ id: "modal.editNotificationGroup.title.sendingMode" })}</div>
          <div className={styles.reportModeOptions}>
            <Radio.Group
              defaultValue="1"
              options={[
                {
                  value: "1",
                  label: <div className={styles.timeSlots}>
                    <div className={styles.labelHead}>
                      {props.formatMessage({ id: "modal.editNotificationGroup.title.timeSlots" })}
                    </div>
                    <div className={styles.label}>
                      {props.formatMessage({ id: "modal.editNotificationGroup.title.timeSlots.details" })}
                    </div>
                    <div className={styles.time}>
                      <TimePicker suffixIcon="" format="HH:mm" />
                      <TimePicker suffixIcon="" format="HH:mm" />
                      <TimePicker suffixIcon="" format="HH:mm" />
                      <TimePicker suffixIcon="" format="HH:mm" />
                    </div>
                  </div>,
                },
                {
                  value: "2",
                  label: <div className={styles.triggered}>
                    <div className={styles.labelHead}>
                      {props.formatMessage({ id: "modal.editNotificationGroup.title.triggered" })}
                    </div>
                    <div className={styles.label}>
                      {props.formatMessage({ id: "modal.editNotificationGroup.title.triggered.details" })}
                    </div>
                    <div>
                      <Input
                        outlined
                        addonAfter="TH/s"
                      />
                    </div>
                  </div>,
                },
              ]}
            />
          </div>
        </div>
      </div>
      <Divider className={styles.divider} />
      <div className={styles.channels}>
        <div className={styles.label}>{props.formatMessage({ id: "modal.editNotificationGroup.title.notificationChannels" })}</div>
        <div className={styles.options}>
          <Checkbox>
            <div className={styles.address}>
              <img src={mail} alt="" />
              <span>{props.formatMessage({ id: "modal.editNotificationGroup.title.email" })}</span>
            </div>
          </Checkbox>
          <Checkbox>
            <div className={styles.address}>
              <img src={telegram} alt="" />
              <span>{props.formatMessage({ id: "modal.editNotificationGroup.title.tg" })}</span>
            </div>
          </Checkbox>
          <Checkbox>
            <div className={styles.address}>
              <img src={apple} alt="" />
              <span>{props.formatMessage({ id: "modal.editNotificationGroup.title.push" })}</span>
            </div>
          </Checkbox>
        </div>
      </div>
    </div>
    <Divider className={styles.divider} />
    <div className={styles.buttons}>
      <Button type="primary" onClick={props.handleClose}>
        {props.name ? props.formatMessage({
          id: "modal.editNotificationGroup.buttons.save"
        }) : props.formatMessage({
          id: "modal.editNotificationGroup.buttons.create"
        })}
      </Button>
      <Button onClick={props.handleClose}>{props.formatMessage({ id: "modal.editNotificationGroup.buttons.cancel" })}</Button>
    </div>
  </div>
}

export default WithModal(MODALS_ENUM.EDIT_NOTIFICATION_GROUP, EditNotificationGroup);
